import { render } from "./CustomerAddresses.html?vue&type=template&id=e99c4938&scoped=true"
import script from "./CustomerAddresses.js?vue&type=script&lang=js"
export * from "./CustomerAddresses.js?vue&type=script&lang=js"

import "./CustomerAddresses.css?vue&type=style&index=0&id=e99c4938&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99c4938"]])

export default __exports__